import { Component, input } from '@angular/core';

@Component({
  selector: 'lib-checkmark-icon',
  standalone: true,
  template: `
    <svg
      [attr.width]="size()"
      [attr.height]="size()"
      viewBox="0 0 10 10"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M1.5 5L4 7.5L8.5 2.5"
        [attr.stroke]="color()"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round" />
    </svg>
  `,
})
export class CheckmarkIconComponent {
  size = input<string>('10');
  color = input<string>('white');
}
